import { memoize } from "lodash";
import { utilBalancing } from "../utils/utilBalancing";
export var selectBalancingPurchaseOfferGroups = memoize(function () { return utilBalancing.getBalancing().PurchaseOfferGroups; });
export var selectBalancingShopOfferGroupById = memoize(function (id) {
    return selectBalancingPurchaseOfferGroups().get(id);
});
export var selectBalancingShopOfferByNameId = memoize(function (id) {
    var offerGroups = Array.from(selectBalancingPurchaseOfferGroups().values());
    for (var _i = 0, offerGroups_1 = offerGroups; _i < offerGroups_1.length; _i++) {
        var offerGroup = offerGroups_1[_i];
        for (var _a = 0, _b = offerGroup.purchaseOffer; _a < _b.length; _a++) {
            var purchaseOffer = _b[_a];
            if (purchaseOffer.nameId === id) {
                return [offerGroup, purchaseOffer];
            }
        }
    }
    return;
});
export var selectBalancingShopOfferGroupByName = memoize(function (name) {
    return Array.from(selectBalancingPurchaseOfferGroups().values()).find(function (element) { return element.name === name; });
});
export var selectBalancingSpecialOffersIds = memoize(function () {
    var offerGroups = Array.from(selectBalancingPurchaseOfferGroups().values());
    return offerGroups
        .filter(function (element) {
        // both leagueReward and LeagueReward are checked in order to include both
        // "leagueReward" and "coopLeagueReward".
        return element.name.indexOf("leagueReward") >= 0 ||
            element.name.indexOf("LeagueReward") >= 0;
    })
        .map(function (element) { return element.purchaseOfferCharacteristicId; });
});
export var selectBalancingPurchaseOfferPackageByNameId = memoize(function (nameId) {
    var findChild = function (child) { return child.nameId === nameId; };
    var offer = Array.from(selectBalancingPurchaseOfferGroups().values()).find(function (element) {
        return element.purchaseOffer.find(findChild) !== undefined;
    });
    if (offer === undefined) {
        return;
    }
    return offer.purchaseOffer.find(findChild);
});
export var balancingPurchaseOfferGroupsMemoizedFunctions = [
    selectBalancingPurchaseOfferGroups,
    selectBalancingShopOfferGroupById,
    selectBalancingShopOfferByNameId,
    selectBalancingShopOfferGroupByName,
    selectBalancingSpecialOffersIds,
    selectBalancingPurchaseOfferPackageByNameId,
];



//////////////////
// WEBPACK FOOTER
// ./src/balancingSelectors/selectBalancingPurchaseOfferGroups.ts
// module id = 188
// module chunks = 3